export const ActivateMobileCoreFlags = {
  MobilePulseLibrary: 'activate-mobile.mobile-pulse',
  MobileAccessHIDV3: 'mobile-access.hidv3',
  ContentLoadingOverlay: 'squad-mobile-platform.content-loading-overlay',
  ContentUsesCache: 'squad-mobile-platform.use-apollo-cache-fetch-policy',
  LocationRequestModalPause: 'squad-mobile.location-request-modal-pause',
  ExtendedSplashScreen: 'squad-mobile.extended-splash-screen',
  ShowSha1AppVersion: 'squad-mobile.show-sha1-app-version',
  UserAccessPermission: 'squad-mobile.user-has-access-permission',
  MobileAccessAppleWallet: 'squad-mobile-access.apple-wallet',
  ShowForcedUpdate: 'squad-mobile-force-update',
  DisplayConsentInWorkplaceSettings:
    'squad-mobile.display-consent-in-workplace-settings',
  HideAppVersionOnLoginScreen: 'squad-mobile.hide-app-version-on-login-screen',
  // Rogue flags
  ActivateMobileTeamTest: 'activate-mobile-team-test',
  ActivateMobileRenderOptimisation: 'activate-mobile.render-optimisation',
  MobilePlatformTestFlag: 'mobile-platform-test-flag',
  MobileSquadAllowCheckCodepush: 'mobile-squad-allow-check-codepush',
  MobileSquadAllowCheckCodepushDot: 'mobile-squad.allow-check-codepush',
  SquadMobileAllowCheckCodepush: 'squad-mobile-allow-check-codepush',
  SquadMobilePlatformPreventSlideReplaceAnimation: 'squad-mobile-platform.prevent-slide-replace-animation',
  SquadMobilePlatformSwitchScrollviewsToLists: 'squad-mobile-platform.switch-scrollviews-to-lists',
  SquadMobileEnableProfileExperimentButton: 'squad-mobile.enable-profile-experiment-button',
  SquadMobileNetworkReachabilityCheck: 'squad-mobile.network-reachability-check',
  // Rogue flags end
} as const;
